import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight, Stethoscope, MessageCircle } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TreatmentGuides from '../components/TreatmentGuides';
import { useLanguage } from '../context/LanguageContext';
import { buildLocalizedPath } from '../components/LocaleRouter';

const GuidesPage = () => {
  const { language } = useLanguage();
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Treatment Guides — VietClinics</title>
        <meta name="description" content="In-depth treatment guides written by VietClinics — what to expect, how to prepare, recovery timelines and how to choose the right clinic in Vietnam." />
        <link rel="canonical" href={typeof window !== 'undefined' ? `${window.location.origin}/guides` : ''} />
      </Helmet>

      <Header />

      {/* Hero */}
      <section className="relative overflow-hidden bg-white">
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none"
          style={{ background: 'linear-gradient(180deg, #F0FAF8 0%, #FAFCFB 65%, #FFFFFF 100%)' }}
        />
        <div className="relative z-10 container mx-auto px-4 max-w-5xl py-16 lg:py-24">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-[0.18em] mb-5"
            style={{ background: '#DCEFEC', color: '#1A8F8A' }}
          >
            <BookOpen className="h-3.5 w-3.5" />
            VietClinics Guides
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight leading-[1.05] mb-5">
            Treatment guides for international patients
          </h1>
          <p className="text-slate-500 text-lg lg:text-xl max-w-2xl leading-relaxed">
            Plain-English walkthroughs of the most-requested treatments in Vietnam —
            what to expect, how to prepare, recovery timelines, costs, and how to
            pick the right clinic for your case.
          </p>

          <div className="flex flex-wrap gap-3 mt-8">
            <Link
              to={buildLocalizedPath('/treatments', language)}
              className="inline-flex items-center gap-2 text-white font-bold rounded-2xl px-7 py-3.5 hover:-translate-y-0.5 transition-all"
              style={{
                background: 'linear-gradient(135deg, #1FA7A1 0%, #178f8a 100%)',
                boxShadow: '0 12px 24px rgba(31,167,161,0.25)',
              }}
            >
              <Stethoscope className="h-4 w-4" />
              Explore all treatments
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to={buildLocalizedPath('/contact', language)}
              className="inline-flex items-center gap-2 bg-white text-[#1FA7A1] font-bold rounded-2xl px-7 py-3.5 border-2 border-[#1FA7A1] hover:bg-[#1FA7A1]/5 transition-all"
            >
              <MessageCircle className="h-4 w-4" />
              Ask our team
            </Link>
          </div>
        </div>
      </section>

      {/* Reuse the homepage Treatment Guides grid */}
      <TreatmentGuides />

      <Footer />
    </div>
  );
};

export default GuidesPage;
